<template>
  <div class="schedule-view">
    <div class="sticky-area">
      <common-header-wrapper title="편성표" :close-fn="close" :back-fn="close" :is-back-btn="true" :is-close-btn="true"></common-header-wrapper>
      <div class="schedule-top-wrap">
        <div class="schedule-top">
          <div id="open-week">
            <button @click="showpopup_sche = true">
              <img src="@/assets/images/ico-schd-cal.png" class="ico-schd-cal" alt="날짜 변경"/>
              <span>{{calDate}}</span>
            </button>
            <template-modal :show="showpopup_sche" @close="showpopup_sche = false">
              <open-popup-sche :data="dateList" :today="selectedDate" @dayClick="dayEvent"/>
            </template-modal>
          </div>
          <div class="today-schedule">
            <p>{{todayText}}</p>
          </div>
          <div class="now-btn" @click.prevent="now">
            <button>NOW</button>
          </div>
        </div>
        <p class="present-time">현재 {{hourMinutes}}</p>
      </div>
      <div class="sche-time-wrap">
        <div class="sche-time-slider">
          <div class="schedule-button prev" @click.prevent="()=>timeMove('prev')"><NextButton /></div>
          <div class="schedule-button next" @click.prevent="()=>timeMove('next')"><NextButton /></div>
          <swiper :options="swiperOptions" ref="scheduleSwiper" @slideChange="swiperChange">
            <swiper-slide v-for="(data, index) in 24" :key="'schedule_' + index">
              <p :class="timeNow(index)" @click="()=>moveToIndex(index)">{{ index | prependNum }}:00</p>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div v-if="dataList" class="sche-channel-wrap"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200">
      <div v-for="(data, index) in dataList" :key="'epgs_' + index">
        <thumb-schedule :data="data" :index="index" :change-alarm-state="changeAlarmState"/>
      </div>
    </div>
    <LoadingWithProps :show-loading="isLoading" />
  </div>
</template>

<script>
import NextButton from '@/assets/svg/common/ic_next_s_p.svg'
import ThumbSchedule from '@/views/schedule/ThumbSchedule'
import OpenPopupSche from '@/views/schedule/OpenPopupSche'
import TemplateModal from '@/views/schedule/TemplateModal'
import { LiveInfoService } from '@/common/api/api.service'
import { get } from 'lodash'
import { infiniteScroll } from '@/common/directives'
import LoadingWithProps from '@/components/LoadingWithProps'
import CommonHeaderWrapper from '@/components/header/template/CommonHeaderWrapper'
export default {
  name: 'ScheduleView',
  components: {
    CommonHeaderWrapper,
    LoadingWithProps,
    NextButton,
    ThumbSchedule,
    TemplateModal,
    OpenPopupSche
  },
  directives: {
    infiniteScroll
  },
  filters: {
    prependNum (num) {
      if (num < 10) {
        return '0' + num
      } else {
        return num
      }
    }
  },
  data () {
    return {
      endOfList: false,
      isLoading: false,
      hourMinutes: '',
      dataList: [], // 데이터 리스트
      dateList: [], // 일주일 날짜 리스트
      selectYear: '',
      selectDate: '',
      selectTime: '',
      startTime: '',
      endTime: '',
      calDate: '',
      todayText: '',
      selectedDate: '',
      selectedYear: '',
      selectedMonth: '',
      selectedDay: '',
      today: '', // 현재 날짜
      curTime: '', // 현재 시간
      startdatetime: '', // 편성표 조회 시작 시각 (2017-09-02 10:00)
      enddatetime: '', // 편성표 조회 종료 시각 (2017-09-03 12:00)
      showpopup_sche: false, // 팝업 오픈 flag
      offset: 0,
      limit: 20,
      swiperOptions: {
        slidesPerView: 3,
        initialSlide: 0,
        centeredSlides: true,
        allowTouchMove: true,
        navigation: {
          nextEl: '.schedule-next',
          prevEl: '.schedule-prev'
        }
      }
    }
  },
  methods: {
    close () {
      this.$router.back()
    },
    changeAlarmState (index, boolState) {
      this.dataList[index].alarm = boolState === true ? 'y' : 'n'
    },
    moveToIndex (index) {
      this.swiper.slideTo(index, 500)
    },
    updateCurTime () {
      let today = new Date()
      let hh = String(today.getHours()).length > 1 ? String(today.getHours()) : '0' + String(today.getHours())
      let mm = String(today.getMinutes()).length > 1 ? String(today.getMinutes()) : '0' + String(today.getMinutes())
      this.hourMinutes = hh + ':' + mm
    },
    resetData () {
      this.dataList = []
      this.endOfList = false
      this.offset = 0
    },
    setTodayDate () {
      const d = new Date()
      this.selectedYear = d.getFullYear()
      this.selectedMonth = d.getMonth() + 1
      this.selectedDay = d.getDate()
    },
    swiperChange () {
      this.resetData()
      this.curTime = this.swiper.activeIndex
      this.$nextTick(() => {
        this.setData()
      })
    },
    timeMove (kind) {
      if (kind === 'next') {
        this.swiper.slideTo(this.swiper.activeIndex + 1, 500)
      } else {
        this.swiper.slideTo(this.swiper.activeIndex - 1, 500)
      }
    },
    timeNow (time) {
      let d = new Date()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hours = d.getHours()
      let className = ''
      this.swiperOptions.initialSlide = hours
      if (time === hours && month === this.selectedMonth && day === this.selectedDay) {
        className = 'time-now'
      }
      return className
    },
    currDate (type, val) {
      let d = new Date()

      if (type === 'B') {
        let week = ['일', '월', '화', '수', '목', '금', '토']
        this.todayText = '오늘은 ' + Number(d.getMonth() + 1) + '월 ' + d.getDate() + '일 ' + week[d.getDay()] + '요일 입니다.'
      }

      if (type === 'A' && val) { this.calDate = val } else { this.calDate = Number(d.getMonth() + 1) + '/' + d.getDate() }
    },
    setDateTime () {
      const pad = (num, width) => {
        const numStr = num + ''
        return numStr.length >= width ? numStr
          : new Array((width - numStr.length) + 1).join('0') + numStr
      }
      const dateFormat = (year, date, time) => {
        return year + '-' + date + ' ' + time + ':00'
      }
      let date = new Date()
      this.selectYear = date.getFullYear()
      if (this.selectedYear) this.selectYear = this.selectedYear
      this.selectDate = pad(date.getMonth() + 1, 2) + '-' + pad(date.getDate(), 2)
      if (this.selectedMonth && this.selectedDay) this.selectDate = pad(this.selectedMonth, 2) + '-' + pad(this.selectedDay, 2)
      if (String(this.curTime).length === 0) this.curTime = date.getHours()
      this.selectTime = this.changeSelectedTime(this.curTime)
      this.selectedDate = this.selectYear + '-' + this.selectDate
      this.startTime = dateFormat(this.selectYear, this.selectDate, pad(this.selectTime, 2))
      this.endTime = dateFormat(this.selectYear, this.selectDate, pad(this.selectTime + 1, 2))
    },
    changeSelectedTime (t) {
      let time = Number(t)
      time = Math.min(time, 23)
      return time
    },
    loadMore () {
      if (this.endOfList || this.isLoading) return
      this.setData()
    },
    setData () {
      this.isLoading = true
      this.setDateTime()
      this.updateCurTime()
      LiveInfoService.getLiveEpgsChannels({
        startdatetime: this.startTime,
        enddatetime: this.endTime,
        offset: this.offset,
        limit: this.limit,
        orderby: 'old'
      }).then(({ data }) => {
        let epgDataList = get(data, 'list', [])
        if (epgDataList.length > 0) {
          this.dataList = this.dataList.concat(epgDataList)
          this.offset += this.limit
        } else {
          this.endOfList = true
        }
        this.isLoading = false
      })
    },
    setSlideToCurrentTime () {
      let d = new Date()
      this.swiper.slideTo(d.getHours() < 10 ? '0' + d.getHours() : d.getHours(), 500)
    },
    now () {
      this.setSlideToCurrentTime()
      this.curTime = this.swiper.activeIndex
      this.currDate('A')
      this.currDate('B')
      this.resetData()
      this.setTodayDate()
      this.setData()
    },
    dayEvent (year, month, day) {
      // 데이터 초기화
      this.setSlideToCurrentTime()
      this.resetData()
      let val = month + '/' + day
      this.currDate('A', val)
      this.selectedYear = year
      this.selectedMonth = month
      this.selectedDay = day
      this.setData()
    }
  },
  computed: {
    swiper () {
      return this.$refs.scheduleSwiper.swiper
    }
  },
  created () {
    let week = ['일', '월', '화', '수', '목', '금', '토']
    // 일주일 날짜 리스트
    for (let i = -3; i < 4; i++) {
      let weekList = { dayList: '', week: '' }
      let d = new Date()

      d.setDate(d.getDate() + i)
      let year = d.getFullYear()
      let month = d.getMonth() + 1
      let day = d.getDate()

      weekList.year = year
      weekList.month = month
      weekList.day = day
      weekList.week = week[d.getDay()]

      this.dateList.push(weekList)
    }
    this.resetData()
    this.setTodayDate()
    this.currDate('A')
    this.currDate('B')
    this.updateCurTime()
  }
}
</script>

<style scoped>
.schedule-view {
  position: relative;
  width: 100%;
  height: 100%;
}
.schedule-top-wrap {
  background-color: #1b1b1b;
  text-align: center;
  height: 70px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.schedule-top {
  padding: 17px 10px 0;
}
.today-schedule {
  float: left;
  width: calc(100% - 114px);
  text-align: center;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
}
.sche-time-wrap{
  background-color: #1b1b1b;
}
.sche-channel-wrap {
  position: relative;
}
#open-week {
  float: left;
  width: 63px;
  height: 24px;
  padding: 0 7px;
  border: 1px solid #fff;
  border-radius: 15px;
  font-size: 0;
}
#open-week button{
  font-size: 0;
}
#open-week button span{
  font-size: 10px;
  line-height: 22px;
  color: #fff;
  font-weight: 700;
}
#open-week button img,
#open-week button span{
  vertical-align: middle;
}
.now-btn button {
  display: block;
  width: 51px;
  height: 24px;
  font-weight: 700;
  font-size: 11px;
  line-height: 24px;
  color: #fff;
  text-align: center;
}
button {
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0;
  border: none;
  background: transparent;
}
.ico-schd-cal {
  width: 16px;
  margin-right: 3px;
}
img {
  outline: none;
}
.now-btn {
  float: left;
  width: 51px;
}
.now-btn button{
  border-radius: 100px;
  background-color: #1351f9;
}
.present-time {
  font-size: 13px;
  line-height: 14px;
  color: #717171;
}
.schedule-top:after {
  content: "";
  display: block;
  clear: both;
}
.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.sche-time-slider {
  position: relative;
}

.schedule-next {
  position: absolute;
  width: 28px;
  height: 100%;
}

.sche-time-slider .swiper-slide {
  text-align: center;
}
.sche-time-slider .swiper-slide p {
  position: relative;
  font-size: 14px;
  color: #a5a5a5;
  line-height: 56px;
}
.sche-time-slider .swiper-slide.swiper-slide-active p {
  color: #3887ff;
}

p.time-now {
  margin-left: -10px;
}
.sche-time-slider .swiper-slide p.time-now:before {
  content: "";
  display: inline-block;
  position: absolute;
  left: 50%;
  top: 12px;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background-color: #3887ff;
  border-radius: 100px;
  vertical-align: middle;
}
  .schedule-button {
    position: absolute;
    width: 27px;
    top: 50%;
    z-index: 200;
    box-sizing: border-box;
  }
  .schedule-button.prev {
    transform: rotate(180deg);
    left: 0;
    margin-top: -10px;
  }
  .schedule-button.next {
    right: 0;
    margin-top: -10px;
  }
  .progress-bar-wrap {
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 3px;
    background: rgba(0,0,0,.15);
    z-index: 100;
  }
  .sche-channel-ing .progress-bar-wrap {
    width: calc(100% - 98px);
    right: 10px;
  }
  .progress-bar {
    display: block;
    height: 100%;
    background: -webkit-gradient(linear,left top,right top,color-stop(0,#5654e1),color-stop(.33,#8a4ee3),color-stop(.66,#717cf0),color-stop(1,#2ac5fe));
    background: -webkit-linear-gradient(95deg,#8a48e3,#35abfd);
    background: -webkit-linear-gradient(355deg,#8a48e3,#35abfd);
    background: linear-gradient(95deg,#8a48e3,#35abfd);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5654e1",endColorstr="#2ac5fe",gradientType=1);
  }

</style>
